import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Observable} from 'rxjs';
import {SchoolsSortingRule, SearchType, SearchTypeName} from 'src/app/model/admin';
import {Page, Pageable} from 'src/app/model/rest/base';
import {FunctionalAccessService} from 'src/app/services/functional-access.service';
import {LocalState} from 'src/app/services/utils/manager-utils';
import {SchoolV3RestService} from "../../services/rest/v3/school-rest.service";
import {SchoolListView, SchoolStatus, SchoolView, V3School} from "../../model/v3/schools";

class SearchForm {
  searchType: SearchType = SearchType.SCHOOL_NAME;
  searchValue: string;
  schoolStatus: SchoolStatus;
  dateAfter: Date;
  dateBefore: Date;
}
@Component({
    selector: 'app-school-list-page',
    templateUrl: './school-list-page.component.html',
    styleUrls: ['./school-list-page.component.scss'],
    standalone: false
})
export class SchoolListPageComponent implements OnInit {
  schoolsPage: Page<SchoolListView>;
  searchForm: SearchForm = new SearchForm();
  sortingRules = SchoolsSortingRule.values;
  currentState: LocalState<SchoolsSortingRule>;
  pageable = new Pageable(0, 10, []);
  sortDirection: 'ASC' | 'DESC' | null = 'ASC'
  sortColumn: string = SchoolsSortingRule.IdAsc.sorting[0]
  loading: boolean = false

  sortColumns = {
    schoolName: SchoolsSortingRule.SchoolNameAsc.sorting[0],
    schoolId: SchoolsSortingRule.IdAsc.sorting[0],
    country: SchoolsSortingRule.CountryAsc.sorting[0],
    status: SchoolsSortingRule.StatusAsc.sorting[0],
    expiry: SchoolsSortingRule.ExpiryAsc.sorting[0],
    activeStudents: SchoolsSortingRule.CountedActiveStudentsAsc.sorting[0],
    activeTeachers: SchoolsSortingRule.ActiveTeachersAsc.sorting[0]
  }

  constructor(
    private faService: FunctionalAccessService,
    private router: Router,
    private schoolV3Rest: SchoolV3RestService,
  ) {}

  ngOnInit(): void {
    this.loadSchools();
    this.currentState = new LocalState(
      '',
      SchoolsSortingRule.Default,
      this.pageable
    );
  }

  loadSchools() {
    this.loading = true
    this.schoolV3Rest.listSchools({pageable: this.pageable}).subscribe((schoolsPage) => {
      this.schoolsPage = schoolsPage as Page<SchoolListView>;
      this.loading = false
    });
  }

  getAllSearchTypes() {
    return SearchType.ALL;
  }

  getSearchTypeName(key: string) {
    return SearchTypeName[key];
  }

  isSearchBySchoolId() {
    return this.searchForm.searchType === SearchType.SCHOOL_ID;
  }
  isSearchByExpDate() {
    return this.searchForm.searchType === SearchType.EXPIRY_DATE;
  }
  isSearchByStatus() {
    return this.searchForm.searchType === SearchType.STATUS;
  }

  getSchoolStatusList() {
    return Object.keys(SchoolStatus);
  }

  getSchoolStatusName(key: string) {
    return SchoolStatus[key];
  }

  resetSearch() {
    this.searchForm = new SearchForm();
    this.updateSearch();
  }

  sortTable(colName: string) {
    this.pageable.page = 0;
    if(this.currentState.sortingRule.sorting[0]?.split(',')[0] === colName){ // change direction
      this.sortDirection = this.sortDirection === 'ASC' ? 'DESC' : 'ASC'
    } else {
      this.sortColumn = colName
      this.sortDirection = 'ASC'
    }

    this.currentState.sortingRule = this.sortingRules.find(sortingRule => {
      if(sortingRule.sorting[0] == colName && sortingRule.sorting[1] == this.sortDirection) return true
    }
    )
    this.pageable.sort[0] = this.currentState.sortingRule.sorting.join()
    this.updateSearch();
  }

  updateSearch() {
    const searchTerm = this.searchForm.searchValue?.toLowerCase();
    let observable = new Observable<Page<SchoolView>>()
    if (!searchTerm && !this.isSearchByExpDate() && !this.isSearchByStatus()) {
      this.schoolV3Rest.listSchools({pageable: this.pageable}).subscribe(schoolsPage => {
        this.schoolsPage = schoolsPage as Page<SchoolListView>
        this.loading = false
      })
      return;
    }

    switch (this.searchForm.searchType) {
      case SearchType.SCHOOL_NAME:
        observable = this.schoolV3Rest.listSchools({pageable: this.pageable, name: searchTerm})
        break;
      case SearchType.SCHOOL_ID:
        observable = this.schoolV3Rest.listSchools({pageable: this.pageable, ids: [+searchTerm]})
        break;
      case SearchType.SCHOOL_OLD_ID:
        observable = this.schoolV3Rest.listSchools({pageable: this.pageable, oldSchoolId: searchTerm})
        break;
      case SearchType.COUNTRY:
        observable = this.schoolV3Rest.listSchools({pageable: this.pageable, country: searchTerm})
        break;
      case SearchType.STATUS:
        observable = this.schoolV3Rest.listSchools({pageable: this.pageable, status: this.searchForm.schoolStatus})
        break;
      case SearchType.EXPIRY_DATE:
        observable = this.schoolV3Rest.listSchools({
          pageable: this.pageable,
          expDateAfter: this.searchForm.dateAfter,
          expDateBefore: this.searchForm.dateBefore
        })
        break;
      default:
        break;
    }

    observable.subscribe(schoolsPage => {
      this.schoolsPage = schoolsPage as Page<SchoolListView>
      this.loading = false
    })
  }

  isNumberInvalid(value: any): boolean {
    return isNaN(+value)
  }

  updateSearchType() {
    this.searchForm.searchValue = null
    this.updateSearch();
  }

  switchPage($event: Pageable) {
    this.pageable = $event
    this.updateSearch()
  }

  navigateBasingOnRole(school: V3School) {
    this.faService.isSuperUser().subscribe(res => {
      if(res)
        this.router.navigate([`/admin/school/${school.id }`]).then()
      else
        this.router.navigate([`/school/${school.id}/dashboard`]).then()
    })
  }
}
